export const defaultSentToLabOptions: string[] = ['CEGAT', 'BGI']
export const defaultFromLabOptions: string[] = ['Locus', 'Φραγκιά']
